import { NavLink } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../assets/logo_v2.png";

const Navbar = () => {
    return (
        <nav className={styles.navbar}>
            <div className={styles.logoContainer}>
                <img src={logo} alt="Downstream logo" className={styles.logoImg} />
                <h2 className={styles.logo}>Downstream</h2>
            </div>
            <div className={styles.navLinks}>
                <NavLink
                    to="/"
                    className={({ isActive }) =>
                        `${styles.navItem} step-overview-2 ${isActive ? styles.active : ""}`
                    }
                >
                    Overview
                </NavLink>

                <NavLink
                    to="/comparison"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Comparison
                </NavLink>

                <NavLink
                    to="/individuals"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Individuals
                </NavLink>

                <NavLink
                    to="/trend"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Trend
                </NavLink>

                <NavLink
                    to="/data"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Early Alerts
                </NavLink>

                <NavLink
                    to="/feedback"
                    className={({ isActive }) =>
                        `${styles.navItem} ${isActive ? styles.active : ""}`
                    }
                >
                    Feedback
                </NavLink>
            </div>

        </nav>
    );
};

export default Navbar;